// RegistrationLinkDashboard.jsx
import React, { useState, useEffect } from 'react';
import { Form, Button, Container, Row, Col, Dropdown, Alert } from 'react-bootstrap';
import axiosInstance from "../../api/axiosConfig.jsx";

const ROLES = {
    BAAS: 'BAAS',
    FLOORMANAGER: 'FLOORMANAGER',
    HUMANRESOURCE: 'HUMANRESOURCE',
    MEDEWERKER: 'MEDEWERKER',
    KLOKSYSTEEM: 'KLOKSYSTEEM',
    CHEFKOK: 'CHEFKOK',
    AFWASSER: 'AFWASSER',
    KEUKENHULP: 'KEUKENHULP',
    SOUSCHEF: 'SOUSCHEF',
};

const RegistrationLinkDashboard = () => {
    const [email, setEmail] = useState('');
    const [firstName, setFirstName] = useState('');
    const [lastName, setLastName] = useState('');
    const [selectedRole, setSelectedRole] = useState('');
    const [companyName, setCompanyName] = useState('');
    const [companyId, setCompanyId] = useState('');
    const [showSuccess, setShowSuccess] = useState(false);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');
    const [userRole, setUserRole] = useState(''); // Toegevoegd voor de huidige gebruiker

    useEffect(() => {
        const authToken = sessionStorage.getItem('authToken');
        if (authToken) {
            const decodedToken = JSON.parse(atob(authToken.split('.')[1]));
            setCompanyName(decodedToken.companyName);
            setCompanyId(decodedToken.companyId);
            setUserRole(decodedToken.role); // Haal de rol van de huidige gebruiker op
        }
    }, []);

    const resetForm = () => {
        setEmail('');
        setFirstName('');
        setLastName('');
        setSelectedRole('');
        setError('');
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setShowSuccess(false);
        setError('');

        const userDTO = {
            email,
            companyName,
            roles: [`${selectedRole}`]
        };

        const companyIdRequestDto = {
            companyId,
            firstName,
            lastName
        };

        try {
            await axiosInstance.post('/users/generate-registration-links', {
                userDTO,
                companyIdRequestDto
            });
            setShowSuccess(true);
            resetForm();
            // Succes melding verdwijnt na 5 seconden
            setTimeout(() => setShowSuccess(false), 5000);
        } catch (error) {
            setError(error.response?.data?.message || 'Er is een fout opgetreden bij het aanmaken van de gebruiker');
        } finally {
            setLoading(false);
        }
    };

    // Filter de beschikbare rollen op basis van de rol van de gebruiker
    const getAvailableRoles = () => {
        if (userRole === 'HORECAMASTERS') {
            return ['HORECAMASTERS.DESIGN', 'HORECAMASTERS.MEDEWERKER'];
        }
        // Alle andere rollen behalve HORECAMASTERS-specific
        return Object.keys(ROLES).filter(role => !role.startsWith('HORECAMASTERS.'));
    };

    return (
        <Container className="mt-5">
            <h1>Genereer Registratielink</h1>
            {showSuccess && (
                <Alert variant="success" className="mt-3">
                    Gebruiker is succesvol aangemaakt! Een registratielink is verzonden naar het opgegeven e-mailadres.
                </Alert>
            )}
            {error && (
                <Alert variant="danger" className="mt-3">
                    {error}
                </Alert>
            )}
            <Form onSubmit={handleSubmit}>
                <Row>
                    <Col md={6}>
                        <Form.Group className="mb-3">
                            <Form.Label>E-mail</Form.Label>
                            <Form.Control
                                type="email"
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                required
                            />
                        </Form.Group>
                    </Col>
                    <Col md={6}>
                        <Form.Group className="mb-3">
                            <Form.Label>Rol</Form.Label>
                            <Dropdown>
                                <Dropdown.Toggle variant="secondary" id="dropdown-role">
                                    {ROLES[selectedRole] || 'Selecteer een rol'}
                                </Dropdown.Toggle>
                                <Dropdown.Menu>
                                    {getAvailableRoles().map(role => (
                                        <Dropdown.Item
                                            key={role}
                                            onClick={() => setSelectedRole(role)}
                                        >
                                            {ROLES[role]}
                                        </Dropdown.Item>
                                    ))}
                                </Dropdown.Menu>
                            </Dropdown>
                        </Form.Group>
                    </Col>
                </Row>
                <Row>
                    <Col md={6}>
                        <Form.Group className="mb-3">
                            <Form.Label>Voornaam</Form.Label>
                            <Form.Control
                                type="text"
                                value={firstName}
                                onChange={(e) => setFirstName(e.target.value)}
                                required
                            />
                        </Form.Group>
                    </Col>
                    <Col md={6}>
                        <Form.Group className="mb-3">
                            <Form.Label>Achternaam</Form.Label>
                            <Form.Control
                                type="text"
                                value={lastName}
                                onChange={(e) => setLastName(e.target.value)}
                                required
                            />
                        </Form.Group>
                    </Col>
                </Row>
                <Button
                    variant="primary"
                    type="submit"
                    disabled={loading}
                >
                    {loading ? 'Bezig met verzenden...' : 'Genereer Registratielink'}
                </Button>
            </Form>
        </Container>
    );
};

export default RegistrationLinkDashboard;
